export default __webpack_public_path__ + "static/media/Bicicleta.3e5ee234.svg";